import { render } from "./Quotation.vue?vue&type=template&id=e9205baa&scoped=true"
import script from "./Quotation.vue?vue&type=script&lang=en"
export * from "./Quotation.vue?vue&type=script&lang=en"

import "./Quotation.vue?vue&type=style&index=0&id=e9205baa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9205baa"]])

export default __exports__